import { Component, OnInit } from '@angular/core';
import { UiStateStore } from '../../../shared/store/ui-state-store.service';
import { DataService } from '../../../dashboards/services/data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JobPost } from '../../models/job-post';


@Component({
  selector: 'app-delete-job',
  templateUrl: './delete-job.component.html',
  styleUrls: ['./delete-job.component.scss']
})
export class DeleteJobComponent implements OnInit {

  jobTitle: string;
  jobPost: JobPost;
  accountId: string;

  constructor(private uiState: UiStateStore, private dataService: DataService, public activeModal: NgbActiveModal) {
    this.uiState.authenticatedUser.subscribe(user => {
      if(!user) {
        return;
      }

      this.accountId = user.accountId;
    });
    
    this.uiState.selectedJobId.subscribe(jobId => {
      if (!jobId) {
        return;
      }

      this.dataService.getJobPost(jobId).subscribe(job => {
        if (!job) {
          return;
        }

        this.jobPost = job;
        this.jobTitle = job.title;
      });

    });
  }

  ngOnInit() {
  }

  deleteJob(response: string): void {
    if (response == "Yes") {
      this.dataService.deleteJobPost(this.jobPost.id).subscribe(r => {
        this.dataService.getJobPosts(this.accountId).subscribe(jp => {
          
        });
      });
    }

    this.activeModal.close();
  }

}
